import * as React from "react";
const SvgArrowForward = props => <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" {...props}><path fill="none" d="M0 0h18v18H0z" /><path d="M9 3 7.94 4.06l4.19 4.19H3v1.5h9.13l-4.19 4.19L9 15l6-6z" /></svg>;
export { SvgArrowForward as ReactComponent };